import React from "react"
import "./style.css"

function spaceReplace(str: string) { return str.replace(/\s+|\s+/g, " ") }

const Button: React.FC<ButtonProps> = ({
    type,
    style,
    loading,
    disabled,
    onClick,
    size,
    className,
    children
}) => {
    return (
        <button
            style={style}
            className={spaceReplace(`sn-btn ${type ? `sn-btn-${type}` : ""} ${size ? `sn-btn-${size}` : ""} ${loading ? "sn-btn-loading" : ""} ${disabled ? "sn-btn-disabled" : ""} ${className ? " " + className : ""}`)}
            disabled={disabled}
            onClick={onClick && !loading ? onClick : void 0}>
            {loading ?
                <svg
                    className="loading"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"><path d="M480 96a32 32 0 0 1 64 0v192a32 32 0 0 1-64 0V96z m250.624 60.64a32 32 0 1 1 51.776 37.632l-112.832 155.328a32 32 0 0 1-51.808-37.632l112.864-155.328z m167.136 196.384a32 32 0 1 1 19.776 60.864l-182.624 59.328a32 32 0 0 1-19.776-60.864l182.624-59.328z m19.776 257.088a32 32 0 1 1-19.776 60.864l-182.624-59.328a32 32 0 0 1 19.776-60.864l182.624 59.328zM782.4 829.76a32 32 0 0 1-51.776 37.632l-112.864-155.328a32 32 0 1 1 51.808-37.632l112.832 155.328zM544 928a32 32 0 0 1-64 0v-192a32 32 0 0 1 64 0v192z m-250.624-60.64a32 32 0 0 1-51.776-37.632l112.832-155.328a32 32 0 0 1 51.808 37.632l-112.864 155.328z m-167.136-196.384a32 32 0 1 1-19.776-60.864l182.624-59.328a32 32 0 0 1 19.776 60.864l-182.624 59.328z m-19.776-257.088a32 32 0 0 1 19.776-60.864l182.624 59.328a32 32 0 1 1-19.776 60.864l-182.624-59.328zM241.6 194.24a32 32 0 1 1 51.776-37.632l112.864 155.328a32 32 0 1 1-51.808 37.632L241.6 194.24z" fill="#ffffff" p-id="2391"></path></svg>
                : <span>{children}</span>}
        </button>
    )
}

interface ButtonProps {
    style?: React.CSSProperties
    className?: string
    children?: React.ReactNode
    type?: "dark" | "primary" | "gradient"
    disabled?: boolean
    loading?: boolean
    size?: "large"

    onClick?(): void
}

export default Button